module.exports = __webpack_public_path__ + "static/media/icn-comment-not-resolved-hover.eaef8c64.svg";